<template>
  <RevCard class="p-24">
    <RevContentBlock
      :button-label="ctaLabel ?? i18n(translations.tryAgainCta)"
      :has-rounded-image="true"
      :image-props="imageProps ?? DEFAULT_IMAGE_PROPS"
      :title="title ?? i18n(translations.title)"
      :title-tag="'p' as 'h2'"
      title-variant="title2"
      @click="onRetry"
    >
      <template #default>
        {{ subtitle ?? i18n(translations.subtitle) }}
      </template>
    </RevContentBlock>
  </RevCard>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevContentBlock } from '@ds/components/ContentBlock'

import translations from './ErrorContainer.translations'

type ImageProps = {
  alt: string
  height: number
  width: number
  src: string
}

defineProps<{
  title?: string
  subtitle?: string
  ctaLabel?: string
  imageProps?: ImageProps
}>()

const emit = defineEmits(['retry'])

const i18n = useI18n()

const DEFAULT_IMAGE_PROPS: ImageProps = {
  alt: '',
  height: 222,
  width: 448,
  src: '/img/common/not-found-block.svg',
}

function onRetry() {
  emit('retry')
}
</script>
